import {decode} from 'html-entities';
export default function decodeHtmlEntities(encodedString) {
    return decode(encodedString);
}